import React, { useState, useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Input,
  Form,
  Label,
  InputGroup,
  InputGroupAddon,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "reactstrap";
import moment from "moment";
import styled from "styled-components";
import _ from "lodash";
import CurrencyFormat from "react-currency-format";

// HELPER
import { TextRupiah } from "../Text";
import { convertToRupiah } from "../../utils";
import { hasError, sneakersCondition, boxCondition } from "../../utils/Helpers";
import {
  ADMINISTRATOR,
  APPROVED,
  SUSPEND,
  REJECTED,
  UNDER_REVIEW,
  WAIT_CONFIRM,
  WAIT_CONSIGN,
  CANCELLED,
  DRAFT,
  MORE_INFO,
  SEMPURNA,
  CACAT,
  NO_BOX,
  BARU,
  BEKAS,
  LISTING,
  getCloudImageUrl,
  emptyImage,
} from "../../utils";

import { Button } from "../Forms";
import Loading from "../../components/Loading";
import Select from "../Forms/Input/Select";
import { getCacheImage } from "../../config";

// IMAGE
import CloseIcon from "../../images/close-button-black.png";
import EditIcon from "../../images/edit-icon.png";
import RightArrowGrey from "../../images/right-arrow-grey.png";
import RightArrowWhite from "../../images/right-arrow-white.png";
import ArrowsNext from "../../images/arrowsNext.png";

import ModalAddressBookV2 from "./ModalAddressBookV2";
import ModalUpdatePaymentOffer from "./ModalUpdatePaymentOffer";
import { BlackHeader } from "../../reusablestyled/HeaderModal";

// ACTION
import {
  getHistoryShipping,
  doPostShippingCost,
} from "../../actions/postalCodeAction";

const getDiffDays = (expiredDate) => {
  var today = new Date();
  var date1 = moment(today);
  var date2 = moment(expiredDate);
  var diff = date2.diff(date1);
  var ONE_DAY = 1000 * 60 * 60 * 24;

  return Math.round(diff / ONE_DAY);
};

const diff = (expiredDate) => {
  return moment(expiredDate).diff(new Date(), "days");
};

const CloseButton = (props) => (
  <div className="closeIcon" style={{ textAlign: "right", padding: ".5rem" }}>
    <KickImage src={CloseIcon} onClick={props.onClick} style={{ width: "15px" }} />
  </div>
);

const disabledInput = (_outOfStock) => {
  if (_outOfStock == true) {
    return true;
  } else {
    return false;
  }
};

const infoString = (data) => {
  switch (data) {
    case SEMPURNA[0]:
      return SEMPURNA[2];
    case CACAT[0]:
      return CACAT[1];
    case NO_BOX[0]:
      return NO_BOX[1];
    case BARU[0]:
      return BARU[2];
    case BEKAS[0]:
      return BEKAS[2];
    case APPROVED:
      return LISTING[0];
    case SUSPEND:
      return LISTING[1];
    case DRAFT[0]:
      return DRAFT[1];
    case MORE_INFO[0]:
      return MORE_INFO[1];
    case CANCELLED[0]:
      return CANCELLED[1];
    case WAIT_CONFIRM[0]:
      return WAIT_CONFIRM[1];
    case WAIT_CONSIGN[0]:
      return WAIT_CONSIGN[1];
    case UNDER_REVIEW[0]:
      return UNDER_REVIEW[1];
    case REJECTED[0]:
      return REJECTED[1];
    default:
      return ADMINISTRATOR;
  }
};

const accessoriesCondition = (data) => {
  switch (data) {
    case false:
      return "Complete Accessories";
    case true:
      return "Missing Accessories";

    default:
      return ADMINISTRATOR;
  }
};

const defectCondition = (bool, data) => {
  switch (bool) {
    case true:
      return detailCondition(data);
    case false:
      return (
        <ButtonWrapper>
          <Button className="btn-black flat">US {data.size}</Button>
          <Button className="btn-black flat">
            {infoString(data.sneakers_condition)}
          </Button>
          <Button className="btn-black flat">Perfect Condition</Button>
        </ButtonWrapper>
      );

    default:
      return (
        <ButtonWrapper>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            US {data.size}
          </Button>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            {infoString(data.sneakers_condition)}
          </Button>
          <Button className="btn-black flat" style={{ cursor: "default" }}>
            Perfect Condition
          </Button>
        </ButtonWrapper>
      );
  }
};

const detailCondition = (data) => {
  const condition = data.defects.filter((item) => item.value);

  return (
    <ButtonWrapper>
      <Button className="btn-black flat" style={{ cursor: "default" }}>
        US {data.size}
      </Button>
      <Button className="btn-black flat" style={{ cursor: "default" }}>
        {infoString(data.sneakers_condition)}
      </Button>
      {condition.map((data, index) => {
        return (
          <Button
            key={index}
            className="btn-black flat"
            style={{ cursor: "default" }}
          >
            {data.display_name}
          </Button>
        );
      })}
    </ButtonWrapper>
  );
};

const goToProductDetail = (props) => {
  const categoryUrl =
    props.dataOffer.category === "apparels" ||
      props.dataOffer.category === "Apparels"
      ? "apparel"
      : props.dataOffer.category === "lifestyles"
        ? "electronics-collectibles"
        : props.dataOffer.category === "handbags"
          ? "luxury"
          : props.dataOffer.category;
  props.history.push(
    `/${categoryUrl}/${props.dataOffer.id}/${props.dataOffer.slug}`
  );
};

const sneakerCondition = (condition) => {
  switch (condition) {
    case "BARU":
      return "Brand New";
    case "BEKAS":
      return "Used";
    case "PRISTINE":
      return "Pristine";
    case "GOOD":
      return "Good";
    case "WELL_USED":
      return "Well Used";
    case "LIKE_NEW":
      return "Like New";
    case "VINTAGE":
      return "Vintage";
    default:
      return "Brand New";
  }
};

const handbagCondition = (data) => {
  return detailHandbagCondition(data);
};

const detailHandbagCondition = (data) => {
  const condition = data
    .filter((item) => item.value)
    .map((item) => item.display_name)
    .join(" / ");

  return condition;
};

const boxHandbag = (value) => {
  if (value === true) {
    return "";
  } else {
    return "Missing Box";
  }
};

const dustBag = (value) => {
  if (value === true) {
    return "";
  } else {
    return "KA Dust Bag";
  }
};

const ModalOfferDetails = (props) => {
  const uniqueDefects =
    props.dataOffer === null ? [] : _.uniqBy(props.dataOffer.defects, "name");
  const dustBagCondition = uniqueDefects
    ? uniqueDefects.find((a) => a.name === "DUST_BAG")
    : {};
  const boxConditions = uniqueDefects
    ? uniqueDefects.find((a) => a.name === "BOX")
    : {};

  const [openEditModal, setOpenEditModal] = useState(false);
  const [openEditOfferModal, setOpenEditOfferModal] = useState(false);
  const [currentOffer, setCurrentOfferPrice] = useState(props.offerAmount);
  const [dropdownOpen, setOpen] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(true);
  const [modalToggle, setModalToggle] = useState(false);
  const [shippingId, setShippingId] = useState(null);
  const [selectedShipping, setSelectedShipping] = useState(null);
  const [defaultId, setDefaultId] = useState(0);
  const [currentPaymentType, setCurentPaymentType] = useState(null);
  const [currentAddress, setCurrentAddress] = useState(null);
  const [currentOfferData, setCurrentOfferData] = useState(null);
  const [isSelectPaymentFlagging, setIsSelectPaymentFlagging] = useState(false);
  const [currentShippingPrice, setCurrentShippingPrice] = useState(null);
  const [isAddressButtonDisable, setIsAddressButtonDisable] = useState(false);
  const [useKickPoints, setUseKickPoints] = useState(false);


  function showModal() {
    setModalToggle(!modalToggle);
  }

  const sneakersDetailArr = [
    sneakerCondition(props.dataOffer.sneakers_condition),
    boxCondition(props.dataOffer.box_condition),
    accessoriesCondition(props.dataOffer.missing_accessories),
  ];

  const sneakersDetail = sneakersDetailArr.map((item) => item).join(", ");

  const toggle = () => setOpen(!dropdownOpen);

  const onErrorImg = (e) => {
    e.target.src = emptyImage(props.dataOffer.category);
  };

  const handleDropdownValue = (value) => {
    setDropDown(value);
    props.updateExpires(value);
  };

  function changeId(id) {
    setIsAddressButtonDisable(true)
    setShippingId(id);
  }

  async function submitShipping(id) {
    setIsAddressButtonDisable(false)
    setDefaultId(shippingId);
    const temp = props.shippingHistory.filter(
      (item) => item.id === shippingId
    )[0];
    setCurrentAddress(temp);
    setSelectedShipping(temp.alias);
    setShippingId(temp.id);
    setModalToggle(!modalToggle);

    const provinceId = props.provinces.filter(
      (prov) => prov.name === temp.province
    );
    const weight =
      props.dataOffer.product_variant && props.dataOffer.product_variant.weight;
    const productVariantId =
      props.dataOffer.product_variant && props.dataOffer.product_variant.id;

    props
      .getShippingFee({
        destination: provinceId[0].id,
        weight: weight || 1000,
        product_variant_id: productVariantId,
        courier: "FLAT_RATE",
      })
      .then((res) => {
        setCurrentShippingPrice(res.value.data);
        props.updateAddress({
          id: temp.id,
          ka_courier: props.dataOffer.ka_courier,
          ka_courier_option: "FLAT_RATE",
          ka_courier_price: res.value.data || props.dataOffer.ka_courier_price,
        });
      });
  }

  useEffect(() => {
    if (props.dataOffer.shipping.id) {
      setCurrentAddress(props.dataOffer.shipping);
      setSelectedShipping(props.dataOffer.shipping.alias);
      setDefaultId(props.dataOffer.shipping.id);
      setShippingId(props.dataOffer.shipping.id);
      setCurrentShippingPrice(props.dataOffer.ka_courier_price);
    }
  }, [props.dataOffer, props.shippingHistory]);

  useEffect(() => {
    setCurrentOfferPrice(props.offerAmount);
    setOpenEditOfferModal(false);
    props.updateExpires(false);
    props.updateAddress(false);
    props.updatePayment(false);
    setShowDropdown(false);
    setDropDown(false);
    setOpenPaymentModal(false);
    setCurrentAddress(props.dataOffer.shipping);
    setIsSelectPaymentFlagging(false);
    props.updateAddress(false);
    setIsAddressButtonDisable(false)
  }, [props.isOpen]);

  const handlePaymentMethodText = (item) => {
    let firstText = "";
    let secondtext = "";

    switch (item.label) {
      case "Mandiri Credit Card / Debit Card":
        firstText = "MANDIRI Credit Card / Debit Card";
        secondtext = "";
        break;
      case "Mandiri Installments":
        firstText = "MANDIRI Installments";
        secondtext = "";
        break;
      case "Credit Card / Debit Card / Installments":
        firstText = "";
        secondtext = "Credit / Debit Card";
        break;
      case "BCA Installments":
        firstText = "BCA Installments";
        secondtext = "";
        break;
      case "Bank Transfer":
        firstText = "Bank Transfer";
        secondtext = "";
        break;
      case "MANDIRI":
        firstText = "MANDIRI";
        secondtext = "Virtual Account";
        break;
      case "BCA":
        firstText = "BCA";
        secondtext = "Virtual Account";
        break;
      case "PERMATA":
        firstText = "PERMATA";
        secondtext = "Virtual Account";
        break;
      case "BNI":
        firstText = "BNI";
        secondtext = "Virtual Account";
        break;
      case "BRI":
        firstText = "BRI";
        secondtext = "Virtual Account";
        break;
      case "GOPAY":
        firstText = "GOPAY";
        secondtext = "";
        break;
      case "Other Virtual Account":
        firstText = "Other Virtual Account";
        secondtext = "";
        break;
      case "Full Wallet":
        firstText = "Kick Credit";
        secondtext = "";
        break;
      default:
        firstText = "MANDIRI";
        secondtext = "Virtual Account";
        break;
    }
    return (
      <p>
        {secondtext} {firstText}
      </p>
    );
  };

  const LuxuryArr = [
    sneakerCondition(props.dataOffer.sneakers_condition),
    accessoriesCondition(props.dataOffer.missingAccessories),
    dustBagCondition?.value ? null : dustBag(dustBagCondition),
    boxConditions?.value ? null : boxHandbag(boxConditions),
    handbagCondition(uniqueDefects),
  ];

  const LuxuryDetails = LuxuryArr.filter((item) => item !== '')
    .map((items) => items)
    .join(' / ');

  return (
    <Modal
      className="kick-modal detail-selling"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <>
        <div
          onClick={props.onToggle}
          style={{ textAlign: "right", padding: "15px", cursor: "pointer" }}
        >
          <KickImage src={CloseIcon} style={{ width: "15px" }} alt="..." />
        </div>

        <Container className="offer-modal-container">
          <ModalBody>
            <Row className="header-info">
              <Col md={9} className="header-info-left">
                <p className="brandname">{props.brandName}</p>
                <p
                  className="display-name"
                  style={{ cursor: "pointer" }}
                  onClick={() => goToProductDetail(props)}
                >
                  <u>{props.dataOffer.display_name}</u>
                </p>
                <p className="sku">{props.dataOffer.SKU}</p>
              </Col>
              {props.dataOffer.category === "handbags" ||
                props.dataOffer.category === "lifestyles" ? null : (
                <Col md={3} className="header-info-right">
                  {

                    props.dataOffer.size === "All Size"
                      ?
                      <div className="size-wrapper" style={{ paddingLeft: 12, paddingRight: 12 }}><p >US {props.dataOffer.size}</p></div>
                      : <div className="size-wrapper"><p>US {props.dataOffer.size}</p></div>
                  }
                </Col>
              )}
            </Row>
            <Row className="image-container">
              <Col>
                <div className="image-wrapper">
                  <KickImage
                    src={
                      props.dataOffer.image_url
                        ? getCloudImageUrl(props.dataOffer.image_url, 400)
                        : emptyImage(props.dataOffer.category)
                    }
                    alt=""
                    onError={(e) => onErrorImg(e)}
                  />
                </div>
              </Col>
            </Row>
            <div className="modal-offer-detail-scroll-content">
              <Row className="detail-info-wrapper">
                <Col className="detail-info-container">
                  <div className="box-wrapper detail-info">
                    <p>Product Conditions</p>
                    {props.dataOffer.isVintage ?
                      'Vintage'
                      : props.dataOffer.category === 'handbags'
                        ? LuxuryDetails
                        : sneakersDetail}
                  </div>

                  <div className="box-wrapper offer-date-wrapper">
                    <p>Offer Date</p>
                    <p>
                      {moment(props.dataOffer.created_at).format("MMMM DD, YYYY")}
                    </p>
                  </div>

                  <div className="box-wrapper box-wrapper-offer-date dropdown-container offer-price">
                    <div className="offer-price-top-content">
                      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                          <div className="offer-expires-left-content offer-expires-title">
                            <p>Offer Expires</p>
                            <p>
                              {dropDown
                                ? moment()
                                  .add(dropDown, "days")
                                  .format("MMMM DD, YYYY")
                                : moment(props.dataOffer.expired_at).format(
                                  "MMMM DD, YYYY"
                                )}
                            </p>
                          </div>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => handleDropdownValue(7)}>
                            Extend 7 Days
                          </DropdownItem>
                          <DropdownItem onClick={() => handleDropdownValue(14)}>
                            Extend 14 Days
                          </DropdownItem>
                          <DropdownItem onClick={() => handleDropdownValue(30)}>
                            Extend 30 Days
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>

                  {currentAddress && (
                    <div
                      className="box-wrapper offer-date-wrapper shipping-address-payment-wrapper"
                      onClick={() => showModal()}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="shipping-address-payment-left-content">
                        <p>Shipping Address</p>
                        <p>{currentAddress.alias}</p>
                      </div>
                      <KickImage
                        className="change-payment-address-icon"
                        src={ArrowsNext}
                        alt="arrow-next"
                      />
                    </div>
                  )}

                  {currentPaymentType && (
                    <div
                      className="box-wrapper offer-date-wrapper shipping-address-payment-wrapper"
                      onClick={() => {
                        setOpenPaymentModal(!openPaymentModal);
                        setCurrentOfferData(props.dataOffer);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="shipping-address-payment-left-content">
                        <p>Payment Method</p>
                        {handlePaymentMethodText(currentPaymentType)}
                      </div>
                      <KickImage
                        className="change-payment-address-icon"
                        src={ArrowsNext}
                        alt="arrow-next"
                      />
                    </div>
                  )}

                  <div className="box-wrapper box-wrapper-offer-date offer-price">
                    <div className="offer-price-top-content">
                      <div className="offer-expires-left-content">
                        <p>Offer Price</p>
                        <Container className="edit-offer-price">
                          <Form onSubmit={props.onSubmit}>
                            <InputGroup
                              className={`offer-price-form ${props.error &&
                                hasError(props.error.errors, "offerAmount")
                                ? ""
                                : "offer-price-form-margin"
                                }`}
                            >
                              <div className="left-mid-input">
                                <InputGroupAddon
                                  addonType="prepend"
                                  className="left-group-addon"
                                >
                                  RP.
                                </InputGroupAddon>
                                <CurrencyFormat
                                  decimalSeparator={","}
                                  thousandSeparator={"."}
                                  value={props.offerAmount}
                                  onKeyPress={props.onKeyPress}
                                  onChange={props.onChangePrice}
                                  name="offerAmount"
                                  onBlur={props.onBlur}
                                  disabled={disabledInput(props._outOfStock)}
                                />
                              </div>
                            </InputGroup>
                            {props.error &&
                              hasError(props.error.errors, "offerAmount") ? (
                              <p className="error-message">
                                {props.error.errors.offerAmount[0].includes(
                                  "You should buy now"
                                ) &&
                                  `${props.error.errors.offerAmount[0]
                                    .split(" ")
                                    .splice(0, 6)
                                    .join(" ")}`}{" "}
                                <span
                                  className="price-error-message"
                                  style={{ fontFamily: "Nunito Bold" }}
                                >
                                  {props.error.errors.offerAmount[0].includes(
                                    "You should buy now"
                                  ) &&
                                    `${props.error.errors.offerAmount[0]
                                      .split(" ")
                                      .splice(8)
                                      .join(" ")}`}
                                </span>
                              </p>
                            ) : null}
                            <Button
                              className="btn-green flat button-save-changes"
                              disabled={
                                (props.isSubmit === true || !props.priceChange) &&
                                !props.isAdressUpdated &&
                                !isSelectPaymentFlagging &&
                                !dropDown
                              }
                            >
                              SAVE CHANGES
                            </Button>
                          </Form>
                        </Container>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="lowest-higher-price">
                <Col>
                  <div className="box-wrapper">
                    <p>Lowest Ask</p>
                    <p>
                      IDR.{" "}
                      {convertToRupiah(parseInt(props.dataOffer.currentLowest))}
                    </p>
                  </div>
                  <div className="box-wrapper">
                    <p>Highest Offer</p>
                    <p>
                      IDR. {convertToRupiah(parseInt(props.dataOffer.highestBid))}
                    </p>
                  </div>
                </Col>
              </Row>
              <Row
                className="delete-container"
                onClick={props.handleDelete}
                style={{ cursor: "pointer" }}
              >
                <p>Delete Offer</p>
              </Row>
            </div>
          </ModalBody>
        </Container>

        <ModalAddressBookV2
          isOpen={modalToggle}
          onToggle={showModal}
          dataAddress={props.shippingHistory}
          countries={props.countries}
          provinces={props.provinces}
          cities={props.cities}
          id={shippingId}
          changeId={changeId}
          defaultId={defaultId}
          submitShipping={submitShipping}
          getHistoryShipping={props.getHistoryShipping}
          isModalOffer={true}
          isAddressButtonDisable={isAddressButtonDisable}
        />
        <ModalUpdatePaymentOffer
          isModalOpen={openPaymentModal}
          onToggle={() => setOpenPaymentModal(!openPaymentModal)}
          handleCurrentPaymentType={(item, enabledKickPoint) => {
            setCurentPaymentType(item);
            props.updatePayment(item && item.payment_method);
            props.handleKickPoints(enabledKickPoint)
          }}
          currentOfferData={props.offerAmount}
          isSelectPaymentFlagging={() => {
            props.handleSelectPaymentFlagging(true);
            setIsSelectPaymentFlagging(true);
          }}
          currentShippingPrice={currentShippingPrice}
        />
      </>
    </Modal>
  );
};

const ButtonWrapper = styled.div`
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: ${(props) =>
    props.hide_box_info ? "1fr 1fr 1fr" : "1fr 1fr 1fr 1fr"};
  grid-column-gap: 0.5rem;
`;

const InactiveWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  span {
    &:first-child {
      color: #dc3545;
      margin-bottom: 5px;
    }
    &:nth-child(2) {
      text-align: center;
      width: 90%;
    }
  }
`;

// export default ModalOfferDetails;

const mapStateToProps = (state) => ({
  shippingHistory: state.dataPostalCode.shippingHistory.data,
  countries: state.dataPostalCode.countries.data,
  cities: state.dataPostalCode.cities.data,
  provinces: state.dataPostalCode.provinces.data,
  dataAuth: state.dataAuth,
});

const mapDispatchToProps = (dispatch) => ({
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  getShippingFee: ({
    destination,
    origin = 153,
    weight = 1000,
    courier = "FLAT_RATE",
    product_variant_id,
  }) =>
    dispatch(
      doPostShippingCost({
        destination,
        origin,
        weight,
        courier,
        product_variant_id,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalOfferDetails);

ModalOfferDetails.defaultProps = {
  imageProduct: null,
};